import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LayoutDashboard, Inbox, Package, Users, LogOut, Globe, BookOpen, FileText } from "lucide-react";

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const items = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/quotations", label: "Quotations", icon: Inbox },
    { to: "/admin/invoices", label: "Invoices", icon: FileText },
    { to: "/admin/products", label: "Products", icon: Package },
    { to: "/admin/blog", label: "Blog", icon: BookOpen },
    { to: "/admin/users", label: "Admins", icon: Users },
  ];

  const onLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col lg:flex-row">
      {/* Sidebar */}
      <aside className="lg:w-72 bg-[#1A201C] text-[#FDFBF7] lg:h-screen lg:sticky lg:top-0 flex flex-col">
        <div className="p-6 border-b border-white/10">
          <img
            src="/ekobiotek-logo-white.webp"
            alt="EKOBIOTEK"
            className="h-12 w-auto mb-4"
          />
          <div className="overline text-[#DE9E36]">Admin panel</div>
          <div className="text-sm text-white/80 mt-1 truncate">{user?.email}</div>
        </div>

        <nav className="flex-1 p-4 space-y-1" data-testid="admin-sidebar">
          {items.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                  isActive
                    ? "bg-[#DE9E36] text-[#1A201C] font-semibold"
                    : "text-white/80 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <Icon size={16} strokeWidth={1.6} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10 space-y-2">
          <NavLink
            to="/"
            className="flex items-center gap-3 px-4 py-3 text-sm text-white/70 hover:text-white transition-colors"
          >
            <Globe size={16} strokeWidth={1.6} />
            View public site
          </NavLink>
          <button
            type="button"
            onClick={onLogout}
            data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-white/70 hover:text-[#DE9E36] transition-colors"
          >
            <LogOut size={16} strokeWidth={1.6} />
            Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
